import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-xl)',
		sm: 'var(--font-size-lg)',
	},
	fontWeight: '800',
	color: 'text.primary',
	textAlign: 'center',
	mt: '10px',
	textTransform: 'uppercase',
};

export const subtitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
	color: 'text.primary',
	textAlign: 'center',
	mt: '12px',
};

export const imgSX: SxProps<Theme> = {
	width: '121px',
	height: '152px',
	objectFit: 'contain',
};

export const gridItemSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'flex-start',
	backgroundColor: '#fff',
	px: { xs: '0px', sm: '30px' },
	paddingTop: { xs: '15px', sm: '30px' },
	paddingBottom: { xs: '15px', sm: '30px' },
};
